import React, { Component } from 'react';
import { ExamListItemAll } from 'components';
import { fromJS } from 'immutable';
import * as common from 'libs/commonFunc';
import './DashboardExamList.css';

class DashboardExamList extends Component {
  render() {
    const { examListOrdering, examListByNo, emptyComponent, selectedExamList } = this.props;


    return (
      <div className="dashboard-exam-list">
        {examListOrdering.size > 0
          ? examListOrdering.map((itemNo, index) => {
            // if (!!examSummaryByExamNo.get(String(itemNo))) {
            const originData = examListByNo.get(String(itemNo)).toJS();
            const changedData = {
              ...originData,
              examEndEpoch: common.epochFromDate(originData.examEndDate),
              examStartEpoch: common.epochFromDate(originData.examStartDate)
            }
            return (
              <ExamListItemAll
                key={index}
                indexNo={index}
                itemNo={itemNo}
                examListData={examListByNo.get(String(itemNo))}
                // examSummaryData={examSummaryByExamNo.get(String(itemNo))}
                examSummaryData={fromJS(changedData)}
                selectedExamList={selectedExamList}
                checkboxHide={true}
                handleSelectExamList={(e) => { return false; }}
                handleCheckExamList={(e) => { return false; }}
              />
            );
            // }
          })
          : emptyComponent
        }
      </div>
    )
  }
}

export default DashboardExamList;


// WEBPACK FOOTER //
// ./src/script/components/dashboard/DashboardExamList.js